import { render, staticRenderFns } from "./bianminfenleiAdd.vue?vue&type=template&id=a0908522&scoped=true"
import script from "./bianminfenleiAdd.vue?vue&type=script&lang=js"
export * from "./bianminfenleiAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0908522",
  null
  
)

export default component.exports